exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-title[data-v-7db0fdb6] {\n    margin-bottom: 0px !important;\n    font-size: 18px !important;\n    padding-top: 16px !important;\n    padding-left: 10px !important;\n}\n.card-description[data-v-7db0fdb6] {\n    margin-bottom: 8px !important;\n}\n.card-border-top[data-v-7db0fdb6] {\n    border-top: 3px solid #149AF9 !important;\n}\n.card-body[data-v-7db0fdb6] {\n    padding: 0px 10px !important;\n}\n.btn[data-v-7db0fdb6] {\n    padding: 7px 7px !important;\n}\ntable tbody tr td[data-v-7db0fdb6]{\n    font-size: 13px;\n}\n", ""]);

// exports
